import { MOBEES_API_URL } from '@shared/constants/API.constants';

export const createMobeesAdApiConfig = data => ({
    url: '/api/ads',
    method: 'POST',
    data,
    baseURL: MOBEES_API_URL,
});

export const updateMobeesAdApiConfig = (adId, data) => ({
    url: `/api/ads/${adId}`,
    method: 'PUT',
    data,
    baseURL: MOBEES_API_URL,
});

export const deleteMobeesAdApiConfig = adId => ({
    url: `/api/ads/${adId}`,
    method: 'DELETE',
    baseURL: MOBEES_API_URL,
});
